module.exports = __webpack_public_path__ + "img/email-icon.f73b8341.svg";